import {combineReducers} from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import liveEventReducer from '../pages/events/liveEvent/slice/liveEventSlice'
import upcomingEventReducer from '../pages/events/upcomingEvent/slice/upcomingEventSlice'
import pastEventReducer from '../pages/events/pastEvent/slice/pastEventSlice'
import createEventReducer from '../pages/events/createEvent/slice/createEventSlice'
import viewEventReducer from '../pages/events/viewEvent/slice/viewEventSlice'
import eventEditReducer from '../pages/eventEdit/slice/eventEditSlice'
import dashboardAnalyticsReducer from '../pages/Dashboard/slice/dashboardAnalytics'


const rootReducers = combineReducers({
    liveEvent:liveEventReducer,
    upcomingEvent:upcomingEventReducer,
    pastEvent:pastEventReducer,
    createEvent:createEventReducer,
    viewEvent:viewEventReducer,
    eventEdit:eventEditReducer,
    dashboardAnalytics:dashboardAnalyticsReducer,
})

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['pastEvent', 'dashboardAnalytics']
}

export const persistedReducer = persistReducer(persistConfig, rootReducers);